module.exports = __webpack_public_path__ + "media/images/design/images/bn_shakyo-9bce40b83df7f1682c899599266de349.jpg";